import { MMButton as LibraryButton } from 'mmfintech-portal-commons'
import type { MMButtonProps } from 'mmfintech-portal-commons/types'

type ButtonVariant = `primary` | `secondary`
// | 'alternative'
// | 'round-primary'
// | 'round-secondary'
// | 'delete'
// | 'dashboard'
// | 'search'
// | 'filter'
// | 'round-filter'
// | 'security'
// | 'security-delete'

export const MMButton = (props: MMButtonProps<ButtonVariant>) => <LibraryButton {...props} />
